export default __webpack_public_path__ + "static/favicon.d3e03b302801da8f708a3d35f3796e24.png";